import React, { useState } from 'react'
import { UploadOutlined } from '@ant-design/icons'
import { Button, message, Upload, Form, Input, Modal } from 'antd'
import axios from 'axios'
import { saveAs } from 'file-saver'

const App = () => {
  const [fileList, setFileList] = useState([])
  const [uploading, setUploading] = useState(false)
  const [imageUrl, setImageUrl] = useState('')
  const [blob, setBlob] = useState(null)
  const [width] = useState('240')
  const [height] = useState('320')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const NumericInput = (props) => {
    const { onChange } = props
    const handleChange = (e) => {
      const { value: inputValue } = e.target
      const reg = /^\d*(\d*)?$/
      if (reg.test(inputValue) || inputValue === '') {
        onChange(inputValue)
      }
    }
    return (
      <Input
        {...props}
        onChange={handleChange}
        placeholder="请输入正整数"
        maxLength={5}
      />
    )
  }
  const handleUpload = (width, height) => {
    const formData = new FormData()
    fileList.forEach((file) => {
      formData.append('idcard', file)
    })
    formData.append('width', width)
    formData.append('height', height)
    setUploading(true)
    // axios
    // 使用axios发送POST请求进行多文件上传
    axios
      .post('/upload/idcard', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        responseType: 'arraybuffer'
      })
      .then((res) => {
        setBlob(res.data)
        setImageUrl(
          'data:image/png;base64,' +
            btoa(
              new Uint8Array(res.data).reduce(
                (previousValue, currentValue) =>
                  previousValue + String.fromCharCode(currentValue),
                ''
              )
            )
        )
        setIsModalOpen(true)
        message.success('上传成功')
      })
      .catch((error) => {
        message.error('上传失败')
        console.log(error)
      })
      .finally(() => {
        setUploading(false)
      })
  }
  // form回调方法
  const onFinish = (values) => {
    const width = values.width
    const height = values.height
    handleUpload(width, height)
  }
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo)
  }
  // Modal回调方法
  const handleOk = () => {
    setIsModalOpen(false)
    // 通过ArrayBuffer判断文件类型，省去前端局部变量持有上传前的文件类型，减少冗余，实现解耦
    const byteArray = new Uint8Array(blob);
    const header = byteArray.subarray(0, 4);
    let imageType = '';
    if (header[0] === 0x89 && header[1] === 0x50 && header[2] === 0x4E && header[3] === 0x47) {
      imageType = 'png';
    } else if (header[0] === 0xFF && header[1] === 0xD8) {
      imageType = 'jpg';
    }
    saveAs(new Blob([blob], { type: imageType === 'png' ? 'image/png' :  'image/jpeg' }), `单寸照.${imageType}`) // 设置下载文件名
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }
  // 上传按钮属性
  const props = {
    onRemove: (file) => {
      const index = fileList.indexOf(file)
      const newFileList = fileList.slice()
      newFileList.splice(index, 1)
      setFileList(newFileList)
    },
    beforeUpload: (file) => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        message.error('只能上传jpg或png格式!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        message.error('上传文件最大10MB!')
        return false
      }
      setFileList([file])
      return false
    },
    fileList
  }
  return (
    <>
      <Upload {...props}>
        <Button icon={<UploadOutlined />}>选取文件</Button>
      </Upload>
      <Form
        name="basic"
        labelCol={{
          span: 4
        }}
        wrapperCol={{
          span: 16
        }}
        style={{
          marginTop: '20px'
        }}
        initialValues={{
          width,
          height
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          label="宽度"
          name="width"
          validateTrigger="onBlur"
          rules={[
            {
              required: true,
              message: '请输入宽度'
            }
          ]}
        >
          <NumericInput />
        </Form.Item>
        <Form.Item
          label="高度"
          name="height"
          validateTrigger="onBlur"
          rules={[
            {
              required: true,
              message: '请输入高度'
            }
          ]}
        >
          <NumericInput />
        </Form.Item>
        <Form.Item
          wrapperCol={{
            offset: 9,
            span: 4
          }}
        >
          <Button
            type="primary"
            htmlType="submit"
            disabled={fileList.length < 1}
            loading={uploading}
            style={{
              marginTop: 16
            }}
          >
            {uploading ? '上传中' : '开始上传'}
          </Button>
        </Form.Item>
      </Form>
      <Modal
        title="转换结果"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="下载"
        cancelText="取消"
      >
        <img src={imageUrl} alt="preview" style={{}} />
      </Modal>
    </>
  )
}
export default App
